"use client";
import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import InnerBanner from "@/components/InnerBanner";
import BannerAddress from "@/components/contact/BannerAddress";
import Address from "@/components/contact/Address";
import ContactForm from "@/components/contact/ContactForm";
import useSplitTextAnimation from "@/components/hooks/useSplitTextAnimation";
import { ParallaxX, ParallaxXR, splitLeft } from "../animation/TextAnimation";
import { FadeUp } from "../animations/TextAnimations";

const AllContact = ({ data }) => {
  const getAboutDataList = data?.page_data;
  const banner = getAboutDataList?.banner;
  const address = getAboutDataList?.address;
  const contact_list = data?.contact_list;
  const filter_list = data?.filter_list;

  // useSplitTextAnimation(".split-up", [data]);

  ParallaxX(data);
  ParallaxXR(data);
  FadeUp(data);
  splitLeft(data);
  return (
    <StyledComponent>
      <InnerBanner
        img={banner?.image ? banner?.image : "/images/static/blur_.jpg"}
        subtitle={banner?.subtitle}
        title={banner?.title}
        text={banner?.desc}
      />
      <BannerAddress data={address} />
      <Address data={contact_list} filter={filter_list} />

      <ContactForm />
    </StyledComponent>
  );
};

const StyledComponent = styled.section``;

export default AllContact;
